import { SKILLS } from "./types";

export const skillsAction = () => {
  return {
    type: SKILLS,
  };
};
